import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Subpage.css';
import '../styles/StrategicEnquiry.css';
import SiteHeader from '../components/SiteHeader';

/**
 * SubpageShell — shared header / footer wrapper for the supporting pages.
 * Delegates the navigation to the shared <SiteHeader/> component so every
 * page (including the landing page) renders the exact same menu markup and
 * behaviour, on desktop and mobile alike.
 */
const SubpageShell = ({ children, currentPath }) => {
  useEffect(() => {
    const hash = window.location.hash?.slice(1);
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'instant' });
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [currentPath]);

  return (
    <div
      className="strategic-page subpage"
      data-testid={`subpage-${currentPath?.replace('/', '') || 'root'}`}
    >
      <SiteHeader currentPath={currentPath} />

      {children}

      <footer className="strategic-footer">
        <p>
          N3URO WORLD<sup>®</sup> · Company No. 16474717 · United Kingdom ·{' '}
          <a href="mailto:hello@n3uro.world">hello@n3uro.world</a>
        </p>
        <p className="site-footer-address" data-testid="footer-address">
          71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ
        </p>
        <p className="strategic-footer-links">
          <Link to="/what-is-n3uro-world" data-testid="footer-what-is">What is N3URO WORLD®?</Link> · <a href="https://www.instagram.com/n3uro_world" target="_blank" rel="me noopener noreferrer" data-testid="footer-instagram">Instagram</a> · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/terms">Terms &amp; Conditions</Link>
        </p>
      </footer>
    </div>
  );
};

export default SubpageShell;
